import { Typography } from "@mui/material";
import { BaseButton } from "v2/components/base/Button/ui";

const BackButton = ({ onClick, title }: { onClick: () => void; title: string }) => {
  return (
    <BaseButton sx={{ borderRadius: "32px" }} variant="white" onClick={onClick}>
      <Typography variant="mobile-action-s-heavy" color="text.btn-dark">
        {title}
      </Typography>
    </BaseButton>
  );
};

export default BackButton;
